import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  client_unit_holidays: [],
  error: null,
  message: '',
};

const Client_unit_wise_holidays = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST:
    case actionTypes.DELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST:
    case actionTypes.UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST:
    case actionTypes.MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS:
    case actionTypes.DELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS:
    case actionTypes.UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS:
    case actionTypes.MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case actionTypes.GET_CLIENT_AND_UNIT_WISE_HOLIDAYS_SUCCESS:
      return {
        ...state,
        loading: false,
        holidays: action.payload,

      }
    case actionTypes.GET_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE:
    case actionTypes.UPDATE_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE:
    case actionTypes.DELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE:
    case actionTypes.UPLOAD_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE:
    case actionTypes.MULTIDELETE_CLIENT_AND_UNIT_WISE_HOLIDAYS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Client_unit_wise_holidays;
